export default __webpack_public_path__ + "static/media/nissan.c4483828.svg";